export default {
  CUSTOMER_GEOLOCATIONS_REPOSITORY: Symbol.for('CUSTOMER_GEOLOCATIONS_REPOSITORY'),
  CREATE_CUSTOMER_GEOLOCATION_COMMAND: Symbol.for('CREATE_CUSTOMER_GEOLOCATION_COMMAND'),
};
